/* BibleBee — shared kernel JS. Section slices own their own behavior. */

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  const themeToggle = document.querySelector('[data-theme-toggle]');

  if (themeToggle) {
    const syncPressed = () => {
      themeToggle.setAttribute('aria-pressed', String(document.documentElement.dataset.theme === 'dark'));
    };

    themeToggle.addEventListener('click', () => {
      const next = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
      document.documentElement.dataset.theme = next;
      try {
        localStorage.setItem('biblebee-theme', next);
      } catch (e) {
        /* private mode — theme still applies for this session */
      }
      syncPressed();
    });

    syncPressed();
  }
});
